<template>
    <a-spin tip="Carregando..." :spinning="spinning">
        <div class="container">
            <a-card>
                <template #title>
                    <a-breadcrumb separator=">">
                        <a-breadcrumb-item>
                            <FileOutlined/>
                            <a href="/configurations/client-images"><span>Imagens Gerais</span></a>
                        </a-breadcrumb-item>
                        <a-breadcrumb-item>
                            {{ isEditMode ? 'Editar Imagem' : 'Cadastrar Imagem' }}
                        </a-breadcrumb-item>
                    </a-breadcrumb>
                </template>
                <a-row style="display: flex; justify-content: space-between; margin: 20px;">
                    <a-col :span="8" style="display: flex; align-items: center;">
                        <strong style="margin-right: 10px;">Nome:</strong>
                        <a-input v-model:value="image.name" style="width: 350px"/>
                    </a-col>

                    <a-col :span="8" style="display: flex; align-items: center;">
                        <strong style="margin-right: 10px;">Descrição:</strong>
                        <a-input v-model:value="image.description" style="width: 350px"/>
                    </a-col>

                    <a-col :span="6" style="display: flex; align-items: center;">
                        <strong style="margin-right: 10px;">Arquivo:</strong>
                        <a-upload :before-upload="beforeUpload" :on-change="handleChange" :show-upload-list="false">
                            <a-button style="display:flex; align-items:center">
                                <UploadOutlined/>
                                Selecionar arquivo
                            </a-button>
                        </a-upload>
                    </a-col>
                </a-row>
                <br/>
                <a-row>
                    <a-col :span="15" class="imgPreview" :style="imgUrl ? { backgroundImage: `url(${imgUrl})` } : {}">
                        <p v-if="showText" style="opacity: 70%">Selecione uma imagem para ver ela aqui</p>
                    </a-col>
                    <a-col :span="8" class="center-flex">
                        <table-view :type="'imagens'"></table-view>
                    </a-col>
                </a-row>
                <a-row style="margin-left:20px">
                    <a-col :span="16" style="display:flex;gap:5px">
                        <a-tooltip :title="isEditMode ? 'Salvar Alterações' : 'Salvar'">
                            <a-button size="large" type="primary" @click="save" class="center-flex">
                                <template #icon>
                                    <SaveOutlined style="font-size: 18px;"/>
                                </template>
                            </a-button>
                        </a-tooltip>
                        <Transition>
                            <div v-if="!showText" style="display:inline-block;">
                                <a-tooltip title="Remover imagem">
                                    <a-button size="large" type="primary" danger class="center-flex"
                                              @click="imageRemove">
                                        <template #icon>
                                            <DeleteOutlined/>
                                        </template>
                                    </a-button>
                                </a-tooltip>
                            </div>
                        </Transition>
                    </a-col>
                </a-row>
            </a-card>
        </div>
    </a-spin>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import {DeleteOutlined, FileOutlined, SaveOutlined, UploadOutlined} from '@ant-design/icons-vue';
import {notification} from 'ant-design-vue';
import "codemirror/mode/htmlmixed/htmlmixed";
import "codemirror/theme/neat.css";
import axios from "axios";
import { openNotification } from "../../../../utils/utilities";

const showText = ref(true);
const imgUrl = ref('');
const props = defineProps(["id"]);
const isEditMode = ref(!!props.id);
const spinning = ref(false);
const selectedFile = ref(null);
const image = reactive({
    id: null,
    name: '',
    description: '',
    path: '',
});

const images = ref([])

const route = '/api/configurations/client-images';

const columns = ref([
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            sorter: {
                compare: (a, b) => a.id - b.id,
            },
            width: 50,
        },
        {
            title: 'Nome',
            dataIndex: 'name',
            key: 'name',
            width: 150,
            sorter: {
                compare: (a, b) => a.name - b.name,
            },
        }
    ]
);

const save = async () => {
    const uploadData = new FormData();
    uploadData.append('file', selectedFile.value);
    uploadData.append('name', image.name);
    uploadData.append('description', image.description);
    uploadData.append('path', image.path);

    if (!image.id) {
        try {
            spinning.value = true
            if (!selectedFile.value) {
                openNotification('error', "Selecione uma imagem");
                spinning.value = false;
                return;
            } else {
                const response = (await window.axios.post(route, uploadData, {
                    headers: {'Content-Type': 'multipart/form-data'}
                }));
                openNotification('success', response.data.message)
            }
            spinning.value = false
            await (new Promise(resolve => setTimeout(resolve, 500)));
            window.location.href = `/configurations/client-images/create`
        } catch (error) {
            spinning.value = false
            openNotification('error', error.message)
        }
    } else {
        try {
            spinning.value = true
            await window.axios.post(route + `/${image.id}`, uploadData, {
                headers: {'Content-Type': 'multipart/form-data'}
            })
            spinning.value = false
            window.location.href = `/configurations/client-images/`
        } catch (error) {
            spinning.value = false
            openNotification('error', error.message)
        }
    }
}

onMounted(async () => {
    if (props.id) {
        try {
            spinning.value = true
            let register = (await window.axios.get(`${route}/${props.id}`)).data.data
            spinning.value = false
            image.id = register.id
            image.name = register.name
            image.description = register.description
            image.path = register.path
            imgUrl.value = register.path;
            showText.value = false
            isEditMode.value = true
        } catch (error) {
            spinning.value = false
            openNotification('error', error.message)
        }
    }

    images.value = (await window.axios.get(route)).data.data.map(image => {
        return {
            id: image.id,
            name: image.name,
            description: image.description,
            path: image.path,
        }
    })
})

const beforeUpload = () => {
    return false;
};

const handleChange = ({file}) => {
    selectedFile.value = file;
    imgUrl.value = URL.createObjectURL(selectedFile.value)
    showText.value = false
};

const imageRemove = () => {
    URL.revokeObjectURL(imgUrl.value)
    imgUrl.value = null
    selectedFile.value = null
    showText.value = true
}

</script>
<style scoped>
.center-flex {
    display: flex;
    justify-content: center;
    align-items: center;
}

.imgPreview {
    display: flex;
    justify-content: center;
    align-items: center;
    border: solid #cacaca 1px;
    border-radius: 5px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    margin: 0 20px 20px 20px;
    padding: 5px;
    height: 600px;

    background-origin: content-box;
    background-color: #d6d6d6;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain; /* ou 'cover' */
}

.v-enter-active,
.v-leave-active {
    transition: opacity 0.2s linear;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>